import React from 'react'
import { DialogContent, Grid, Typography } from '@mui/material'
import { InterstitialAutoTraderLogo, InterstitialZutoLogo } from '@zuto/icons'
import CheckedList from '../../CheckedList'
import AnimatedArrows from '../../Animations/AnimatedArrows'

const list = [
  'Car finance to suit all circumstances',
  'You\'ll get an answer in minutes',
  'Auto Trader\'s preferred partner'
]

const AutotraderInterstitialContent = (): JSX.Element => {
  return (
    <DialogContent sx={{ py: 12 }}>
      <Grid className="interstitial-header" container spacing={1} columns={3} alignItems="center" justifyContent="space-between" mb={7}>
        <Grid><InterstitialAutoTraderLogo data-testid="autotrader-logo" /></Grid>
        <Grid><AnimatedArrows data-testid="animated-arrows" /></Grid>
        <Grid><InterstitialZutoLogo data-testid="zuto-logo" /></Grid>
      </Grid>
      <Typography variant="h3" color="#666" mb={2}>Let&apos;s check your eligibility</Typography>
      <CheckedList list={list} />
    </DialogContent>
  )
}

export default AutotraderInterstitialContent
